/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudDownloadAlt, faInfoCircle, faMicrophone, faCheckDouble, faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import FilesList from './files-list/files-list.component';
import FileUpload from '../../common/components/file-upload/file-upload.component';
import {
  isiOSMobileButNotSafari
} from '../../common/helpers/common.helpers';
// import SearchBox from './search-box/search-box.component';  Request ANSUZ-9247 - to hide search bar for now(not finished).
import { AUDIO_FILE_TYPES, IOS_SAFARI_ONLY, ZERO_VALUE, FILES_REMOVE_MESSAGE, ALERT_ERROR, MAX_FILES } from '../../constants/constants';
import routes, { PATH_FILE_DETAILS } from '../../routes';
import './dashboard.style.scss';

/**
 * Class representing the dashboard component.
 * @extends Component
 * */
@inject('filesStore', 'commonStore')
@observer
class Dashboard extends Component {
  static propTypes = {
    filesStore: PropTypes.shape({
      files: PropTypes.arrayOf(PropTypes.shape({})),
      loadFiles: PropTypes.func.isRequired,
      numberOfFiles: PropTypes.number,
      numberOfSelectedFiles: PropTypes.number,
      searchFiles: PropTypes.func.isRequired
    }),
    commonStore: PropTypes.shape({
      openConfirmation: PropTypes.func,
      show: PropTypes.func,
    }),

    history: PropTypes.shape({
      push: PropTypes.func.isRequired
    }).isRequired
  };

  static defaultProps = {
    commonStore: {
      openConfirmation: () => { },
      show: () => {},
    },
    filesStore: {
      files: [],
      numberOfFiles: 0,
      numberOfSelectedFiles: 0
    }
  };

  filesContinerRef = React.createRef();

  /**
   * Loads the files and binds scroll event.
   * */
  async componentDidMount() {
    //alert(window.innerHeight);
    const { filesStore: { addEventScroll, loadFiles, numberOfFiles } } = this.props;

    addEventScroll();
    // if (numberOfFiles === ZERO_VALUE) {
    //   await loadFiles();
    // }
    await loadFiles();
  }

  /**
   * Navigates to file details.
   *  @param {number} id - The file id.
   * */
  onGoToFile = (id) => {
    const { history } = this.props;
    history.push(`${PATH_FILE_DETAILS}/${id}`);
  };

  /**
   * Navigates to record page.
   * */
  onGoToRecordPage = () => {
    const { history, commonStore: { show }, filesStore: { numberOfFiles } } = this.props;
    if (isiOSMobileButNotSafari(navigator, window)) {
      // eslint-disable-next-line
      alert(IOS_SAFARI_ONLY);
    } else if(numberOfFiles >= 200){
      show(MAX_FILES, ALERT_ERROR);
    } else {
      history.push(`${routes.recorder}`);
    }
  };

  /**
   * Search by query string.
   * @param {string} value - The query string.
   * */
  onFileSearch = async (value) => {
    const { filesStore } = this.props;

    await filesStore.searchFiles(value);
  };

  /**
   * Returns true if at least one file is selected.
   * @return {bool} value - Multiple selection state.
   * */
  isMultipleSelection = () => {
    const { filesStore: { numberOfSelectedFiles } } = this.props;

    return (numberOfSelectedFiles > 0);
  };

  /**
   * Toggles file selection state.
   * @param {number} id - The file id.
   * @param {bool} isChecked - The new checked state.
   * */
  onFileSelectChange = (id, isChecked) => {
    const { filesStore: { setFileSelection } } = this.props;
    setFileSelection(id, isChecked);
  };

  /**
   * Call to unselect the checked files
   * */
  onClearSelections = () => {
    const { filesStore: { resetFilesSelection } } = this.props;
    resetFilesSelection();
  };


  onSelectAll = () => {
    const { filesStore: { allFilesSelection } } = this.props;
    allFilesSelection();
     
  };

  /**
   * Call to download files from Amazon
   * */
  onDownload = () => {
    const { filesStore: { downloadFilesFromAmazon } } = this.props;
    downloadFilesFromAmazon();
  };

  /**
   * Opens the confirmation popup for removing the files.
   * */
  handleRemove = () => {
    const { commonStore: { openConfirmation } } = this.props
    openConfirmation(FILES_REMOVE_MESSAGE, this.onRemove);
  };

  /**
   * Removes the files.
   * */
  onRemove = async () => {
    const { filesStore: { removeFiles } } = this.props;
    await removeFiles();
  };

  render() {
    // For deailing with mobile browser UI
    const innerheightcalc = window.innerHeight;
    const fileListheightCalc = innerheightcalc * 0.76;
    const fileListSectionStyle = {
      height: fileListheightCalc+'px'
    };

    const {
      filesStore: {
        files,
        setFilesContinerRef
      }
    } = this.props;
    return (
      <div className="container-fluid">
        <div className={`file-section container ${this.isMultipleSelection() ? 'clear-visible' : ''}`}>
          <div className="dashboard col-12">
            {/*
            <div className="filters-section container">
              Request ANSUZ-9247 - to hide search bar for now(not finished).
              <SearchBox onFileSearch={this.onFileSearch} />
            </div>
            */}
            <div ref={(node) => { setFilesContinerRef(node); }} className="files-list-section" style={fileListSectionStyle}>
              <div className="scroll-content">
              
                  <div className="filters-section container text-center">

                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={this.onSelectAll}
                      >
                        <FontAwesomeIcon icon={faCheckDouble} size="lg"/>&nbsp;<span>Select All</span>
                      </button>

                      <button
                        className="btn btn-outline-secondary clear-selections"
                        type="button"
                        onClick={this.onClearSelections}
                      >
                        <FontAwesomeIcon icon={faTimes} size="lg"/>&nbsp;<span>Clear</span>
                      </button>
     
                  </div>
              
                <FilesList
                  files={files}
                  hideGoToFile={this.isMultipleSelection()}
                  onGoToFile={this.onGoToFile}
                  onFileSelectChange={this.onFileSelectChange}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="footer-container">
          <div className="file-footer container-fluid">
              <div className="footer-wrapper col-sm-12 col-md-10 offset-md-1 col-lg-6 offset-lg-3">
                <div className="row">
                  {!this.isMultipleSelection() && (
                  <FileUpload accept={AUDIO_FILE_TYPES} />
                  )}
                  {!this.isMultipleSelection() && (
                  <div className="col-6 text-center btn-div">
                    <button type="button" className="btn btn-link" onClick={this.onGoToRecordPage}>
                    <FontAwesomeIcon icon={faMicrophone} size="2x"/><br /><span>Record</span>
                  </button>
                  </div>
                  )}
                  {this.isMultipleSelection() && (
                  <div className="col-6 text-center btn-div">
                    <button type="button" className="btn btn-link" onClick={this.onDownload}>
                    <FontAwesomeIcon icon={faCloudDownloadAlt} size="2x"/><br /><span>Download</span>
                  </button>
                  </div>
                  )}
                  {this.isMultipleSelection() && (
                  <div className="col-6 text-center btn-div">
                    <button type="button" className="btn btn-link" onClick={this.handleRemove}>
                    <FontAwesomeIcon icon={faTrashAlt} size="2x"/><br /><span>Remove</span>
                  </button>
                  </div>
                  )}
                </div>
              </div>
              {!this.isMultipleSelection() && (
              <div className="file-info-section">
                <div className="info text-center">
                  <FontAwesomeIcon icon={faInfoCircle} size="lg" color="green" />
                  <small>
                    &nbsp;
                    <strong>File types: </strong>mp3, wav &nbsp;
                    <strong>Size limit: </strong>10mb
                  </small>
                </div>
              </div>
              )}
              
          </div>
        </div>

      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/messages/dashboard/dashboard.component.js